document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lookbook-section').forEach(function (section) {

    /* ---------- VER MÁS ---------- */
    var loadMoreBtn = section.querySelector('[data-loadmore]');
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        section.querySelectorAll('.lookbook-product-card.is-hidden').forEach(function (card) {
          card.classList.remove('is-hidden');
        });
        loadMoreBtn.classList.add('is-hidden');
      });
    }

    /* ---------- QUICK ADD TO CART ---------- */
    section.querySelectorAll('.lookbook-product-card__quickadd[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (btn.classList.contains('is-loading')) return;

        var variantId = btn.getAttribute('data-variant-id');
        var originalText = btn.textContent;

        btn.classList.add('is-loading');

        fetch(window.Shopify ? '/cart/add.js' : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('add-to-cart-failed');
            return res.json();
          })
          .then(function () {
            btn.classList.remove('is-loading');
            btn.classList.add('is-added');
            btn.textContent = 'Añadido ✓';

            // Avisa al drawer/carrito del theme si existe un evento global
            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            setTimeout(function () {
              btn.classList.remove('is-added');
              btn.textContent = originalText;
            }, 1800);
          })
          .catch(function () {
            btn.classList.remove('is-loading');
            btn.textContent = 'Sin stock';
            setTimeout(function () {
              btn.textContent = originalText;
            }, 1800);
          });
      });
    });
  });
});